export const PEEQBACK_ICON_PATHS = {
  firstBubble:
    "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
  secondBubble:
    "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
} as const;

export const PEEQBACK_ICON_COLORS = {
  firstBubble: "#6359E9",
  secondBubble: "#9993F1",
} as const;

const PEEQBACK_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="${PEEQBACK_ICON_COLORS.firstBubble}" d="${PEEQBACK_ICON_PATHS.firstBubble}"/><path stroke="${PEEQBACK_ICON_COLORS.secondBubble}" d="${PEEQBACK_ICON_PATHS.secondBubble}"/></svg>`;

export const PEEQBACK_ICON_DATA_URI = `data:image/svg+xml;utf8,${encodeURIComponent(
  PEEQBACK_ICON_SVG
)}`;
